import request from '@/utils/request'
import { disPostParams } from '@/utils/common.js'
import { getId } from '../../utils/auth';

export function getinfo() {
    let data = {
        id: getId()
    }
    return request({
        url: "/spreader/user/getinfo",
        headers: {
            isToken: true,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function updatepwd(data) {
    return request({
        url: "/spreader/user/updatepwd",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function updatepwdt(data) {
    return request({
        url: "/spreader/user/updatepwdt",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function getTelCode(data) {
    return request({
        url: "/spreader/user/getTelCode",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function getProtocolStatus() {
    let data = {
        id: getId()
    }
    return request({
        url: "/spreader/user/getProtocolStatus",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function setProtocolStatus() {
    let data = {
        id: getId()
    }
    return request({
        url: "/spreader/user/setProtocolStatus",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function updateInfo(data) {
    return request({
        url: "/spreader/user/update",
        headers: {
            isToken: true,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function wxlogin(data) {
    return request({
        url: "/spreader/user/wxlogin",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}


// WEBPACK FOOTER //
// ./src/api/spreader/user.js